var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonegray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6297 5.96964C13.55 10.211 10.211 13.55 5.96964 14.6297C4.364 15.0385 3 13.6569 3 12V11.25C3 10.8358 3.33662 10.5039 3.74881 10.4631C4.44522 10.3941 5.11361 10.2298 5.74078 9.98343L6.88024 11.1229C8.73352 10.236 10.236 8.73353 11.1229 6.88025L9.98342 5.74079C10.2298 5.11362 10.3941 4.44522 10.4631 3.74881C10.5039 3.33662 10.8358 3 11.25 3H12C13.6569 3 15.0385 4.364 14.6297 5.96964Z",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonegray);
export default __webpack_public_path__ + "static/media/phonegray.3f4b66efec06cff398804e8c72383067.svg";
export { ForwardRef as ReactComponent };